import { errorEventEmitter, ErrorMessage, ErrorService, LnErrorEvent } from "./ErrorService";
import { useEffect, useMemo } from "react";
import { onNextDialogClose } from "../Modalservice/Dialogservice";
import DOMPurify from 'dompurify';
import classes from "./Errors.module.scss";
import { useI18n } from "src/utils/lni18n";
import { useAlert } from "../Modalservice/UseAlert";

const ErrorComponent = () => {

    const { languageService: t } = useI18n();
    const alert = useAlert();



    const showErrors = useMemo(() => {
        return (messages: ErrorMessage[]) => {

            // error at login. Display as dialog and then reset the error message
            if (messages && messages.length > 0) {

                const showErrorsInternal =  async () => {
                    const nodes = messages.map((message, i) => {
                        let messageComponent = null;
                        if (message.htmlMessage) {
                            messageComponent = <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message.htmlMessage) }} />
                        }
                        else {
                            messageComponent = <div className="preserve-white">
                                {message.message}
                            </div>;
                        }

                        return ( <div className="mb-5" key={i}>
                            <div className="mb-2 fw-bold d-flex" role="alert">
                                <div className="flex-fill">{message.header}</div>
                                <div>{t.getShortDateTimeString(message.when)}</div>
                            </div>
                            {messageComponent}
                        </div> );
                    });

                    const list = <div className={classes.errorList}>{nodes}</div>;

                    return alert("lg", t.getText("error"), list)
                        .finally(() => ErrorService.clearAllErrors());
                };

                onNextDialogClose().then(showErrorsInternal);

            }
        }
    }, [t, alert]);

    useEffect(() => {
        const listener = errorEventEmitter.on("errorChanged", (event: LnErrorEvent) => {
            if( event.inDialogContext ) return;
            showErrors(event.data);
        });
        
        if( listener !== null ) {
            return () => listener.dispose();
        }

    }, [showErrors]);

    return <></>
}


export default ErrorComponent; 